module.exports = __webpack_public_path__ + "static/media/resources1.413aa700.jpg";